export default __webpack_public_path__ + "static/media/Vaidehi.707594c9.jpg";